import React from "react";

const AddEventModal = ({
  closeModal,
  formData,
  setFormData,
  handleSubmit,
  errors,
  editingEvent,
  saving,
  updateReminder,
  removeReminder,
  addReminder,
  handleFileChange,
}) => {
  return (
    <div className="modal-backdrops" onClick={closeModal}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {/* Header */}
        <div className="modal-header">
          <h2 id="modal-title" className="modal-title">
            {editingEvent ? "Edit Event" : "Add New Event"}
          </h2>
          <button
            onClick={closeModal}
            className="close-btn"
            aria-label="Close modal"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Scrollable Body */}
        <div className="modal-body">
          <form onSubmit={handleSubmit} id="eventForm">
            <section className="form-section">
              <h3 className="section-title">Basic Information</h3>
              <div className="form-group">
                <label htmlFor="title">Event Title *</label>
                <input
                  id="title"
                  type="text"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  placeholder="e.g. Quarterly VAT submission"
                  required
                />
                {errors.title && <span className="error">{errors.title}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      description: e.target.value,
                    })
                  }
                  placeholder="e.g. Prepare and submit VAT return..."
                />
              </div>
              <div className="form-group">
                <label htmlFor="dueDate">Due Date *</label>
                <input
                  id="dueDate"
                  type="date"
                  value={formData.dueDate}
                  onChange={(e) =>
                    setFormData({ ...formData, dueDate: e.target.value })
                  }
                  required
                />
                {errors.dueDate && (
                  <span className="error">{errors.dueDate}</span>
                )}
              </div>
            </section>

            <section className="form-section">
              <h3 className="section-title">Details</h3>
              <div className="form-row">
                <div className="form-group half">
                  <label htmlFor="eventType">Event Type</label>
                  <select
                    id="eventType"
                    value={formData.eventType}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        eventType: e.target.value,
                      })
                    }
                  >
                    <option value="reminder">Reminder</option>
                    <option value="meeting">Meeting</option>
                    <option value="health">Health</option>
                    <option value="logistics">Logistics</option>
                    <option value="maintenance">Maintenance</option>
                  </select>
                </div>
                <div className="form-group half">
                  <label htmlFor="category">Category *</label>
                  <input
                    id="category"
                    type="text"
                    value={formData.category}
                    onChange={(e) =>
                      setFormData({ ...formData, category: e.target.value })
                    }
                    placeholder="e.g. VAT Quarterly"
                    required
                  />
                  {errors.category && (
                    <span className="error">{errors.category}</span>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group half">
                  <label htmlFor="timeline">Timeline</label>
                  <select
                    id="timeline"
                    value={formData.timeline}
                    onChange={(e) =>
                      setFormData({ ...formData, timeline: e.target.value })
                    }
                  >
                    <option value="upcoming">Upcoming</option>
                    <option value="past">Past</option>
                  </select>
                </div>
                <div className="form-group half">
                  <label htmlFor="status">Status</label>
                  <select
                    id="status"
                    value={formData.status}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                  >
                    <option value="todo">To Do</option>
                    <option value="inprogress">In Progress</option>
                    <option value="pending">Pending</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="completed">Completed</option>
                    <option value="done">Done</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="priority">Priority</label>
                <select
                  id="priority"
                  value={formData.priority}
                  onChange={(e) =>
                    setFormData({ ...formData, priority: e.target.value })
                  }
                >
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>
            </section>

            <section className="form-section">
              <h3 className="section-title">Reminders</h3>
              {formData.reminders.map((rem, idx) => (
                <div key={idx} className="dynamic-item">
                  <div className="form-group mb-0">
                    <label>Reminder Date *</label>
                    <input
                      type="date"
                      value={rem.reminderDate}
                      onChange={(e) =>
                        updateReminder(idx, "reminderDate", e.target.value)
                      }
                      required
                    />
                    {errors[`reminderDate_${idx}`] && (
                      <span className="error">
                        {errors[`reminderDate_${idx}`]}
                      </span>
                    )}
                  </div>
                  <div className="form-group mb-0 flex-1">
                    <label>Notes *</label>
                    <input
                      type="text"
                      value={rem.notes}
                      onChange={(e) =>
                        updateReminder(idx, "notes", e.target.value)
                      }
                      placeholder="e.g. Collect receipts"
                      required
                    />
                    {errors[`notes_${idx}`] && (
                      <span className="error">{errors[`notes_${idx}`]}</span>
                    )}
                  </div>
                  <button
                    type="button"
                    className="remove-btn icon-only"
                    onClick={() => removeReminder(idx)}
                    title="Remove Reminder"
                  >
                    🗑️
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="btn-outline add-more-btn mt-3"
                onClick={addReminder}
              >
                + Add Reminder
              </button>
            </section>

            <section className="form-section mb-0">
              <h3 className="section-title">Attachments</h3>
              <div className="form-group file-upload-group">
                <label htmlFor="attachments" className="file-upload-label">
                  <div className="upload-icon">📄</div>
                  <span>Upload Files (PDF, images, docs)</span>
                  <span className="upload-hint">
                    Drag & drop or click to browse
                  </span>
                </label>
                <input
                  id="attachments"
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.png,.doc,.docx"
                  className="visually-hidden"
                />

                {formData.attachments.length > 0 && (
                  <div className="file-list mt-3">
                    {formData.attachments.map((file, idx) => (
                      <div key={idx} className="file-item">
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">
                          {(file.size / 1024).toFixed(1)} KB
                        </span>
                        {errors[`attachment_${idx}`] && (
                          <span className="error error-inline">
                            {errors[`attachment_${idx}`]}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </section>
          </form>
        </div>
        {/* Fixed Footer */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={closeModal}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="eventForm"
            className="btn-primary"
            disabled={saving}
          >
            {saving
              ? "Saving..."
              : editingEvent
                ? "Update Event"
                : "Create Event"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEventModal;
